import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import PropTypes from 'prop-types';
import { intlMessageShape } from './intlMessageShape';
export const location = {
  pathname: PropTypes.string,
  search: PropTypes.string,
  hash: PropTypes.string,
  state: PropTypes.shape({})
};
export const intlLocation = {
  pathname: intlMessageShape,
  search: PropTypes.string,
  hash: intlMessageShape,
  state: PropTypes.shape({})
};
export const toShape = PropTypes.oneOfType([PropTypes.string, PropTypes.shape(location)]);
export const intlToShape = PropTypes.oneOfType([intlMessageShape, PropTypes.shape(intlLocation)]);
export const isIntlToShapeLocation = to => {
  var _context;
  return to !== undefined && typeof to !== 'string' && _someInstanceProperty(_context = ['pathname', 'search', 'hash', 'state']).call(_context, property => property in to);
};